import { get } from './client.js';

export const getBilling  = (orgId) => get(`/orgs/${orgId}/billing`);
export const getInvoices = (orgId) => get(`/orgs/${orgId}/billing/invoices`);
